import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EMPTY } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ConfirmDialogService } from '../../dialog/confirm-dialog/confirm-dialog.service';
import { BookingRuleService } from './bookingrule.service';

/** Dependencies required to run the shared booking rule delete flow. */
export interface DeleteBookingRuleOptions {
  /** Id of the booking rule to delete. */
  id: string;
  service: BookingRuleService;
  dialogService: ConfirmDialogService;
  destroyRef: DestroyRef;
  /** Called after the booking rule has been removed successfully. */
  onDeleted: () => void;
}

/**
 * Runs the shared "Verwijderen" flow for a booking rule. A booking rule is a
 * leaf record (nothing references it), so it only asks for confirmation before
 * deleting.
 */
export function deleteBookingRuleWithChecks(options: DeleteBookingRuleOptions): void {
  const { id, service, dialogService, destroyRef, onDeleted } = options;

  dialogService.open({
    width: '320px',
    title: 'Verwijderen?',
    message: 'Boekingsregel verwijderen?',
    cancelText: 'Nee',
    confirmText: 'Ja',
    variant: 'error',
  });

  dialogService
    .confirmed()
    .pipe(
      take(1),
      switchMap((confirmed) => {
        if (!confirmed) {
          return EMPTY;
        }

        return service.removeBookingRule(id);
      }),
      takeUntilDestroyed(destroyRef),
    )
    .subscribe({
      next: () => onDeleted(),
      error: () => undefined,
    });
}
